// Axis catalog for diagnostic-course questions ("Preguntas (Primaria)" mode),
// keyed by subject code. Subjects without an entry — or with an empty list —
// hide the per-question axis selector. NOT to be confused with
// EJES_ARTICULADORES_COURSE below, which is the NEM "ejes articuladores"
// concept and is unrelated to diagnostic question axes.
export const DIAGNOSTIC_QUESTION_AXES_BY_SUBJECT_CODE: Record<
  string,
  string[]
> = {
  math: [
    "Numeración",
    "Sumas y restas",
    "Multiplicación y división",
    "Fracciones y proporcionalidad",
    "Razonamiento lógico",
    "Medición",
    "Geometría",
    "Análisis de datos",
  ],
  // Grammar axes will be defined in a separate ticket; empty for now so the
  // selector stays hidden for GRAM1 diagnostics.
  GRAM1: [],
};

export const EJES_ARTICULADORES_COURSE: string[] = [
  "Inclusión",
  "Pensamiento crítico",
  "Interculturalidad crítica",
  "Igualdad de género",
  "Vida saludable",
  "Artes y experiencias estéticas",
  "Apropiación de las culturas a través de la lectura y escritura",
];
